module.exports = __webpack_public_path__ + "static/media/align-right-color.903cb71e.svg";